import { useState } from "react";
import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL || "";

function Logo({ size = 28 }) {
  return (
    <span
      style={{
        fontFamily: "Inter, Nunito, sans-serif",
        fontSize: size,
        fontWeight: 800,
        letterSpacing: "-0.045em",
        lineHeight: 1,
        background: "linear-gradient(118deg, #0d9488 0%, #14b8a6 42%, #fb7185 100%)",
        WebkitBackgroundClip: "text",
        WebkitTextFillColor: "transparent",
        backgroundClip: "text",
      }}
    >
      oryyn
    </span>
  );
}

const FEATURES = {
  free: [
    "10 searches per minute",
    "Standard AI answers",
    "Cited web sources",
    "Related questions",
    "Search history (7 days)",
  ],
  pro: [
    "Unlimited searches",
    "Priority AI answers",
    "Deeper source analysis",
    "Unlimited search history",
    "Saved answers library",
    "No ads, ever",
    "Faster response times",
    "Early access to new features",
    "Priority support",
  ],
};

const FAQS = [
  { q: "Can I cancel anytime?", a: "Yes — cancel with one click from your account settings. No fees, no questions." },
  { q: "What payment methods do you accept?", a: "All major credit and debit cards via Stripe — secure and encrypted." },
  { q: "Is my data private?", a: "Your searches are never sold. Pro is billed securely through Stripe." },
  { q: "What's the difference in speed?", a: "Pro users get priority inference, so answers come back faster and with deeper source analysis." },
];

export default function ProPage() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  async function handleUpgrade() {
    const token = localStorage.getItem("oryyn_token");
    if (!token) {
      setError("Please sign in first to upgrade.");
      return;
    }
    setLoading(true);
    setError("");
    try {
      const res = await axios.post(
        `${API_URL}/pro/checkout`,
        {},
        { headers: { Authorization: `Bearer ${token}` } }
      );
      window.location.href = res.data.url;
    } catch (err) {
      setError(err.response?.data?.detail || "Something went wrong. Please try again.");
      setLoading(false);
    }
  }

  return (
    <div className="pro-page">
      <header className="pro-nav">
        <a href="/" className="pro-nav-logo"><Logo size={26} /></a>
        <a href="/" className="pro-nav-back">← Back to Search</a>
      </header>

      <section className="pro-hero">
        <span className="pro-badge">✨ Oryyn Pro</span>
        <h1 className="pro-title">Search <span className="grad">without limits</span></h1>
        <p className="pro-subtitle">
          Unlock the full power of Oryyn AI — unlimited searches, faster answers, and zero ads.
        </p>
      </section>

      <section className="pro-pricing">
        <div className="pro-card">
          <div className="pro-card-name">Free</div>
          <div className="pro-card-price">$0<span>/month</span></div>
          <p className="pro-card-tag">Perfect for casual searching</p>
          <div className="pro-card-current">Current plan</div>
          <ul className="pro-features">
            {FEATURES.free.map((f) => (
              <li key={f}><span className="pro-check">✓</span>{f}</li>
            ))}
          </ul>
        </div>

        <div className="pro-card pro-card-featured">
          <span className="pro-popular">Most popular</span>
          <div className="pro-card-name accent">Pro</div>
          <div className="pro-card-price">$9.99<span>/month</span></div>
          <p className="pro-card-tag">For power users and researchers</p>
          {error && <div className="pro-error">{error}</div>}
          <button className="pro-cta" onClick={handleUpgrade} disabled={loading} type="button">
            {loading ? "Redirecting…" : "Upgrade to Pro →"}
          </button>
          <ul className="pro-features">
            {FEATURES.pro.map((f) => (
              <li key={f}><span className="pro-check">✓</span>{f}</li>
            ))}
          </ul>
          <p className="pro-fineprint">Cancel anytime. No questions asked.</p>
        </div>
      </section>

      <section className="pro-faq">
        <h2>Frequently asked questions</h2>
        {FAQS.map((faq) => (
          <div className="pro-faq-item" key={faq.q}>
            <div className="pro-faq-q">{faq.q}</div>
            <div className="pro-faq-a">{faq.a}</div>
          </div>
        ))}
      </section>
    </div>
  );
}
